document.addEventListener('DOMContentLoaded', function () {
  var grids = document.querySelectorAll('.subcollections__grid');

  grids.forEach(function (grid) {
    var section = grid.closest('.subcollections__inner');
    var scrollbar = section.querySelector('.subcollections__scrollbar');
    var thumb = section.querySelector('.subcollections__scrollbar-thumb');
    if (!scrollbar || !thumb) return;

    var isDragging = false;
    var dragStartX = 0;
    var dragStartScrollLeft = 0;

    function updateAlignment() {
      var overflowing = grid.scrollWidth > grid.clientWidth + 1;
      grid.classList.toggle('is-scrollable', overflowing);
      scrollbar.classList.toggle('is-active', overflowing);
      updateThumb();
    }

    function updateThumb() {
      if (grid.scrollWidth <= grid.clientWidth) return;
      var thumbWidthPct = (grid.clientWidth / grid.scrollWidth) * 100;
      var maxScroll = grid.scrollWidth - grid.clientWidth;
      var scrollPct = maxScroll > 0 ? grid.scrollLeft / maxScroll : 0;
      var trackWidth = scrollbar.clientWidth;
      var thumbWidthPx = (thumbWidthPct / 100) * trackWidth;
      var maxThumbTravel = trackWidth - thumbWidthPx;

      thumb.style.width = thumbWidthPct + '%';
      thumb.style.transform = 'translateX(' + (scrollPct * maxThumbTravel) + 'px)';
    }

    // ---- drag the thumb to scroll the grid ----
    function startDrag(clientX) {
      isDragging = true;
      dragStartX = clientX;
      dragStartScrollLeft = grid.scrollLeft;
      thumb.classList.add('is-dragging');
      document.body.style.userSelect = 'none';
    }

    function moveDrag(clientX) {
      if (!isDragging) return;
      var trackWidth = scrollbar.clientWidth;
      var thumbWidthPx = thumb.offsetWidth;
      var maxThumbTravel = trackWidth - thumbWidthPx;
      var maxScroll = grid.scrollWidth - grid.clientWidth;
      if (maxThumbTravel <= 0) return;

      var deltaX = clientX - dragStartX;
      var scrollDelta = (deltaX / maxThumbTravel) * maxScroll;
      grid.scrollLeft = dragStartScrollLeft + scrollDelta;
    }

    function endDrag() {
      isDragging = false;
      thumb.classList.remove('is-dragging');
      document.body.style.userSelect = '';
    }

    // mouse
    thumb.addEventListener('mousedown', function (e) {
      e.preventDefault();
      startDrag(e.clientX);
    });
    document.addEventListener('mousemove', function (e) {
      if (isDragging) moveDrag(e.clientX);
    });
    document.addEventListener('mouseup', endDrag);

    // touch
    thumb.addEventListener('touchstart', function (e) {
      startDrag(e.touches[0].clientX);
    }, { passive: true });
    document.addEventListener('touchmove', function (e) {
      if (isDragging) moveDrag(e.touches[0].clientX);
    }, { passive: true });
    document.addEventListener('touchend', endDrag);

    // click anywhere on the track (not the thumb) to jump-scroll
    scrollbar.addEventListener('click', function (e) {
      if (e.target === thumb) return;
      var rect = scrollbar.getBoundingClientRect();
      var clickX = e.clientX - rect.left;
      var trackWidth = scrollbar.clientWidth;
      var thumbWidthPx = thumb.offsetWidth;
      var maxThumbTravel = trackWidth - thumbWidthPx;
      var maxScroll = grid.scrollWidth - grid.clientWidth;
      var targetThumbX = Math.min(Math.max(clickX - thumbWidthPx / 2, 0), maxThumbTravel);
      grid.scrollLeft = (targetThumbX / maxThumbTravel) * maxScroll;
    });

    window.addEventListener('load', updateAlignment);
    window.addEventListener('resize', updateAlignment);
    grid.addEventListener('scroll', updateThumb);
    grid.querySelectorAll('img').forEach(function (img) {
      img.addEventListener('load', updateAlignment);
    });

    updateAlignment();
  });

  // scroll-trigger onscreen reveal (unchanged)
  var triggers = document.querySelectorAll('.scroll-trigger');
  if ('IntersectionObserver' in window && triggers.length) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('scroll-trigger--onscreen');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    triggers.forEach(function (el) { observer.observe(el); });
  } else {
    triggers.forEach(function (el) { el.classList.add('scroll-trigger--onscreen'); });
  }
});